import React from 'react'

import { arrayOf, bool, number, func } from 'prop-types'

import NumberOfItems from './NumberOfItems'
import PaginationCard from './PaginationCard'
import PerPage, { DEFAULT_PER_PAGE_OPTIONS } from './PerPage'

function Pagination({
  currentPage,
  totalPages,
  totalCount,
  perPage,
  onPageChange: handlePageChange,
  onPerPageChange: handlePerPageChange,
  alwaysShow = false,
  perPageOptions = DEFAULT_PER_PAGE_OPTIONS,
}) {
  if (!alwaysShow && totalPages <= 1) {
    return null
  }

  return (
    <div className="shared-pagination">
      <NumberOfItems
        totalCount={totalCount}
        perPage={perPage}
        currentPage={currentPage}
      />
      <PaginationCard
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      <PerPage
        perPage={perPage}
        onPerPageChange={handlePerPageChange}
        options={perPageOptions}
      />
    </div>
  )
}

Pagination.propTypes = {
  currentPage: number.isRequired,
  totalPages: number.isRequired,
  totalCount: number.isRequired,
  perPage: number.isRequired,
  onPageChange: func.isRequired,
  onPerPageChange: func.isRequired,
  alwaysShow: bool,
  perPageOptions: arrayOf(number),
}

export default Pagination
